import Grid from '@material-ui/core/Grid';
import React from 'react';
import {
  HorizontalBreak,
  MandateDetails,
  MandateExpirationDateInput,
} from './components';

const DetailsFormGroup = () => {
  return (
    <Grid container={true}>
      <Grid item={true}>
        <MandateExpirationDateInput />
      </Grid>
      <Grid item={true} xs={12}>
        <HorizontalBreak />
      </Grid>
      <Grid item={true} xs={12}>
        <MandateDetails />
      </Grid>
    </Grid>
  );
};

export default DetailsFormGroup;
